import { TableColumn } from "../table/TableColumn";
import { SearchTerm } from "./SearchTerm";

const AccessProfileSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "apName",
        translationKey: "name"
    },
    {
        heading: "Description",
        accessor: "description",
        searchOnName: "apDesc",
        translationKey: "description"
    },
];

export default AccessProfileSearch;